import { render, staticRenderFns } from "./InvocationsChart.component.vue?vue&type=template&id=2c786e2c&"
import script from "./InvocationsChart.component.vue?vue&type=script&lang=js&"
export * from "./InvocationsChart.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports